import {useContext} from 'react'
import {SearchBarContext} from './SearchBarContext'

const styles = {
  iconButton: {
    fontSize: '1.5rem'
  },
  searchInput: {
    border: 'none'
  },
  clearIcon: {
    fontSize: '1rem',
    transform: 'rotate(45deg)'
  }
}
export const SearchBar = () => {
  const {search, setSearch} = useContext(SearchBarContext)

  return (
    <div className="vw-dashboard__main__header__search">
      <button className="btn btn-link" style={styles.iconButton}>
        <i className="fal fa-search"></i>
      </button>
      <input
        type="text"
        className="form-control"
        style={styles.searchInput}
        placeholder="Search"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      {search && (
        <button className="btn btn-link" style={styles.clearIcon} onClick={() => setSearch('')}>
          <i className="fal fa-plus"></i>
        </button>
      )}
    </div>
  )
}
